<div class="card">
    <div class="title">
        <mat-icon class="icon">error</mat-icon>
        <span class="title-text">
            @if(petitions().personal){
            Tiene <strong>{{petitions().days}}</strong> días <strong>personales</strong> pendientes de aprobación
            } @else {
            Tiene <strong>{{petitions().days}}</strong> días pendientes de aprobación
            }
        </span>
    </div>

    <div class="dates">
        {{petitions().startDate}} - {{petitions().endDate}}
    </div>
    <div class="buttons">
        <button mat-flat-button id="action">Aprobar petición</button>
        <button mat-flat-button id="delete">Rechazar</button>
    </div>
</div>